document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".card__heading a, .full-unstyled-link").forEach(link => {
    let flipped = false;
    let timeout;

    link.addEventListener("click", function (e) {
      const card = link.closest(".card-wrapper");
      const inner = card?.querySelector(".flip-card-inner");

      if (!inner) return;

      // First tap → flip
      if (!flipped) {
        e.preventDefault();
        flipped = true;

        inner.classList.add("is-flipped");

        clearTimeout(timeout);

        timeout = setTimeout(() => {
          inner.classList.remove("is-flipped");
          flipped = false;
        }, 3000);
      }
    });
  });
});